import React, { useState } from "react";
import { IMG_RESOURCE } from "../../../services/request/urls";
import { ProjectItem } from "../../../stores/User/AppStore";
import styles from "./index.module.scss";
import { useNavigate } from "react-router";
import { Tooltip } from "antd";
import AuthStore from "../../../stores/AuthStore";
export interface CardBoxProps {
  project: ProjectItem;
}

const CardBox: React.FC<CardBoxProps> = (props) => {
  const [curApp, setCurApp] = useState<number>(0);
  const navigate = useNavigate();

  const enterApp = () => {
    AuthStore.linkToSubsystem(props.project.refUrlAppVoList[curApp].key);
    // window.open(
    //   "/sso/pass?appkey=" + props.project.refUrlAppVoList[curApp].key,
    //   "blank"
    // );
  };

  return (
    <div className={styles.project_card}>
      <div className={styles.cover_wrapper}>
        <img
          alt=""
          src={`${IMG_RESOURCE}/${props.project.refUrlAppVoList[curApp]?.pictureUrl}`}
          onError={(e) => {
            e.currentTarget.src = "/imgs/default-cover.png";
          }}
        />

        <div className={styles.cover_mask}>
          {/* <button onClick={() => navigate(``)}>详情</button> */}
          <button
            onClick={() =>
              navigate(
                `/user/list/${props.project.id}/${props.project.refUrlAppVoList[curApp].id}`
              )
            }
          >
            详情
          </button>
          <button onClick={enterApp}>进入</button>
        </div>
      </div>

      <div className={styles.app_info}>
        <p className={styles.project_name}>{props.project.name}</p>
        <p className={styles.app_tab}>
          {props.project.refUrlAppVoList.map((app, idx) => (
            <span
              className={idx === curApp ? styles.active : undefined}
              key={idx}
              onClick={() => setCurApp(idx)}
            >
              {app.name}
            </span>
          ))}
        </p>
        {props.project.des ? (
          <Tooltip title={props.project.des ?? "暂无简介"} placement="top">
            <p className={styles.app_desc}>{props.project.des ?? "暂无简介"}</p>
          </Tooltip>
        ) : (
          <p className={styles.app_desc}>暂无简介</p>
        )}
      </div>
    </div>
  );
};

export default CardBox;
